
import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already set consent preference
    const hasConsent = localStorage.getItem('analytics_consent');
    if (!hasConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setVisible(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const acceptCookies = () => {
    // Set consent and load analytics
    if (window.setAnalyticsConsent) {
      window.setAnalyticsConsent(true);
    }
    setVisible(false);
  };

  const declineCookies = () => {
    // Decline consent
    if (window.setAnalyticsConsent) {
      window.setAnalyticsConsent(false);
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white p-4 shadow-lg border-t border-gray-200">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="mb-4 md:mb-0 pr-4">
          <h3 className="text-lg font-bold mb-1">Cookie Settings</h3>
          <p className="text-sm text-gray-700">
            We use cookies to enhance your browsing experience and analyze our traffic. 
            By clicking "Accept", you consent to our use of cookies for analytics purposes.
          </p>
        </div>
        <div className="flex space-x-3">
          <Button 
            variant="outline"
            onClick={declineCookies}
            className="border-phcsn-navy text-phcsn-navy hover:bg-phcsn-navy hover:text-white"
          >
            Decline
          </Button>
          <Button 
            onClick={acceptCookies}
            variant="default"
            className="bg-phcsn-navy text-white hover:bg-phcsn-navy/90"
          >
            Accept
          </Button>
        </div>
        <Button 
          variant="ghost" 
          size="icon" 
          className="absolute top-2 right-2 md:hidden"
          onClick={() => setVisible(false)}
          aria-label="Close cookie consent banner"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
